export default {
    namespaced: true,
    state: () => ({
        webSiteList: []
    }),
    mutations: {
        setWebSiteList(state, list) {
            state.webSiteList = Array.isArray(list) ? list : []
        }
    }
}
